import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import DateObject from "react-date-object";
import axios from "../api/axiosInstance";
import { getOpenOrderItems } from "../services/OpenOrdersService";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { CustomerContext } from "../context/customerContext";

const OpenOrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const openOrdersMeta = location.state || {};
  const [openOrderItems, setOpenOrderItems] = useState([]);
  const [openOrders, setOpenOrders] = useState([]);
  const { customer, setCustomer } = useContext(CustomerContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        // دریافت لیست آیتم‌های حواله باز
        const itemsRes = await getOpenOrderItems(id);

        if (Array.isArray(itemsRes.data)) {
          setOpenOrderItems(itemsRes.data);
        }
      } catch (err) {
        console.error(" خطا در دریافت آیتم‌های حواله باز:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading || !openOrderItems) {
    return (
      <DashboardLayout>
        <div className="text-center text-gray-500 mt-10" dir="rtl">
          در حال بارگذاری...
        </div>
      </DashboardLayout>
    );
  }

  const totalAmount = openOrderItems.reduce(
    (sum, item) => sum + item.netPrice,
    0
  );

  const totalCount = openOrderItems.reduce(
    (sum, item) => sum + item.majorUnitQuantity,
    0
  );

  const currentOpenOrder = openOrders.find(
    (item) => item.orderID.toString() === id
  );
  const remainAmount = currentOpenOrder?.remainAmount || 0;

  return (
    <DashboardLayout>
      <div
        className="mt-6 p-6 bg-white rounded-xl shadow-lg space-y-6"
        dir="rtl"
      >
        {/* هدر صفحه */}
        <div className="flex justify-between items-center border-b pb-3">
          <h2 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
            جزئیات حواله باز
          </h2>
          <button
            onClick={() => navigate(-1)}
            className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
          >
            بازگشت
          </button>
        </div>

        {/* اطلاعات کلی فاکتور */}
        <div className="space-y-2 bg-blue-50 text-blue-900 px-5 py-4 rounded-md border border-blue-100 shadow-sm">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1">
            <p>
              شماره حواله: <strong>{openOrdersMeta.number}</strong>
            </p>
            <p>
              تاریخ:
              <strong>
                {openOrdersMeta.date &&
                  new DateObject({
                    date: openOrdersMeta.date,
                    calendar: "gregorian",
                  })
                    .convert(persian)
                    .format("YYYY/MM/DD")}
              </strong>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1">
            <p>
              نام مشتری: <strong>{customer.customerName}</strong>
            </p>
            <p>
              کد مشتری: <strong>{customer.customerCode}</strong>
            </p>
          </div>
        </div>

        {/* جدول اقلام فاکتور */}
        <div className="max-h-[400px] overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
          <table className="w-full min-w-[480px] text-sm text-right">
            <thead className="bg-gray-100 text-gray-600">
              <tr>
                <th className="py-2 px-3">ردیف</th>
                <th className="py-2 px-3">نام محصول</th>
                <th className="py-2 px-3 text-center">تعداد</th>
                <th className="py-2 px-3 text-left">مبلغ (ریال)</th>
              </tr>
            </thead>
            <tbody>
              {openOrderItems.map((item, index) => (
                <tr
                  key={index}
                  className={`border-t ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="py-2 px-3">{item.rowNumber}</td>
                  <td className="py-2 px-3">{item.productName}</td>
                  <td className="py-2 px-3 text-center">
                    {item.majorUnitQuantity}
                  </td>
                  <td className="py-2 px-3 text-left">
                    {item.netPrice === 0 || item.netPrice === null
                      ? "کالای رایگان"
                      : item.netPrice.toLocaleString()}
                  </td>
                </tr>
              ))}
              {openOrderItems.length === 0 && (
                <tr>
                  <td colSpan="4" className="py-4 text-center text-gray-400">
                    آیتمی برای نمایش وجود ندارد.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* جمع کل - ریسپانسیو */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 bg-blue-100 text-blue-900 font-semibold rounded-lg px-5 py-4 border border-blue-200 mt-4">
          {/* جمع تعداد اقلام */}
          <div className="flex items-center gap-2">
            <span>جمع تعداد اقلام:</span>
            <span>{totalCount.toLocaleString()}</span>
          </div>

          {/* جمع مبلغ */}
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span>جمع خالص فاکتور:</span>
              <span>{totalAmount.toLocaleString()} ریال</span>
            </div>
            {/* <div className="flex items-center gap-2 mt-1">
              <span>مانده تسویه نشده:</span>
              <span className="text-red-600">
                {remainAmount.toLocaleString()} ریال
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default OpenOrderDetails;
